import React from "react";
import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import img from "../../assets/images/background/13.jpg"
import Footer from "../../components/layout/Footer";
import BilletTab from "../../components/products/BilletTab";
function Billet() {
  return (
    <>
      <MainHeader />
      <PageHeader image={img} title={"Billet"}/>
      <BilletTab />
      <Footer />
    </>
  );
}

export default Billet;
